// extracted by mini-css-extract-plugin
module.exports = {"assessmentComment":"assessmentComment_assessmentComment__2O32q"};